<template>
  <div>
    <!-- 上傳按鈕 -->
    <v-btn
      color="primary"
      @click="isShowUploadFileDialog = true"
      class="ml-2"
      :disabled="btnDisabled"
    >
      上傳圖片
    </v-btn>

    <!-- 圖片顯示 Dialog -->
    <v-dialog v-model="isShowUploadFileDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="headline">圖片管理</v-card-title>

        <v-card-text>
          <!-- 圖片上傳區域 -->
          <div class="upload-area mb-4">
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              multiple="multiple"
              @change="handleFileSelect"
            />

            <v-btn
              color="primary"
              outlined
              block
              @click="$refs.fileInput.click()"
              class="py-8"
              :disabled="isLoading"
            >
              <v-icon large class="mr-2">mdi-cloud-upload</v-icon>
              點擊選擇圖片
            </v-btn>
          </div>

          <!-- 圖片預覽網格 -->
          <div v-if="uploadPhotoList.length > 0">
            <h3 class="mb-3">已選擇的圖片 ({{ uploadPhotoList.length }})</h3>
            <v-row>
              <v-col
                v-for="(uploadPhoto, index) in uploadPhotoList"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card class="image-card">
                  <div class="image-container">
                    <img :src="uploadPhoto.url" :alt="uploadPhoto.name" class="preview-image" />

                    <!-- 刪除按鈕 -->
                    <v-btn
                      fab
                      small
                      color="error"
                      class="delete-btn"
                      @click="removeImage(index)"
                      :disabled="isLoading"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <!-- 圖片資訊 -->
                  <v-card-text class="pa-2">
                    <div class="text-caption text-truncate">
                      {{ uploadPhoto.name }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ formatFileSize(uploadPhoto.size) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <!-- 空狀態 -->
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-2">mdi-image-outline</v-icon>
            <p class="grey--text mt-2">尚未選擇任何圖片</p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="closeUploadFileDialog" :disabled="isLoading">
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn
            text
            color="success"
            @click="confirmImages"
            :disabled="uploadPhotoList.length === 0"
            :loading="isLoading"
          >
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImageUploadDialog',
  props: {
    btnDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowUploadFileDialog: false,
      uploadPhotoList: []
    }
  },
  methods: {
    closeUploadFileDialog () {
      this.uploadPhotoList = []
      this.isShowUploadFileDialog = false
    },

    handleFileSelect (event) {
      const files = Array.from(event.target.files)

      files.forEach((file) => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader()

          reader.onload = (e) => {
            this.uploadPhotoList.push({
              file: file,
              name: file.name,
              size: file.size,
              url: e.target.result
            })
          }

          reader.readAsDataURL(file)
        }
      })

      // 清空input值，允許重複選擇同一文件
      event.target.value = ''
    },

    removeImage (index) {
      this.uploadPhotoList.splice(index, 1)
    },

    confirmImages () {
      this.$emit('uploadPhotos', this.uploadPhotoList)
    },

    formatFileSize (bytes) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  }
}
</script>

<style scoped>
.image-card {
  position: relative;
  height: 200px;
}

.image-container {
  position: relative;
  height: 150px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
}

.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 16px;
  transition: border-color 0.3s ease;
}

.upload-area:hover {
  border-color: #1976d2;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
